import React, { useState, CSSProperties } from 'react'
import { SVGProps } from '../types/svg'
import COLORS from '../styles/colors'
import commonStyles from '../styles/globalStyles'
import Triangle from '../assets/svgs/Triangle'

interface Props {
  detailsOptions: {
    id: number
    Icon: React.FC<SVGProps>
    inputName: string
    detail: string
  }[]
  selectedOptions: { [detail: string]: boolean }
  type: string
  onClick: (detailType: string, detail: string) => void
  Icon: React.FC<SVGProps>
  text: string
}

const Accordion = (props: Props) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div style={styles.container}>
      <button onClick={() => setIsOpen(!isOpen)} style={styles.accordionButton}>
        <props.Icon color={COLORS.gray} />
        <p style={styles.buttonText}>{props.text}</p>
        <Triangle style={styles.dropdownIcon(isOpen)} color={COLORS.gray} />
      </button>
      {isOpen && (
        <div style={styles.optionsContainer}>
          {props.detailsOptions.map((option) => {
            const selected = Boolean(props.selectedOptions[option.inputName])
            return (
              <button
                key={option.id}
                onClick={() => props.onClick(props.type, option.inputName)}
                style={styles.optionButton(selected)}
              >
                <option.Icon color={selected ? COLORS.greyscale.white : COLORS.gray} />
                <p style={styles.optionText(selected)}>{option.detail}</p>
              </button>
            )
          })}
        </div>
      )}
    </div>
  )
}

const styles = {
  container: {
    marginBottom: 24,
  },
  accordionButton: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: 16,
    // border: `1px solid ${COLORS.greyscale.dark}`,
    width: '100%',
    boxShadow: commonStyles.general.shadow,
    backgroundColor: 'transparent',
    borderRadius: 2,
    border: `1px solid ${COLORS.lightGray}`,
    position: 'relative',
  } as CSSProperties,
  buttonText: {
    marginLeft: 15,
    fontSize: 16,
    color: COLORS.gray,
    fontWeight: 700,
    textAlign: 'left',
  } as CSSProperties,
  dropdownIcon: (isOpen: boolean) =>
    ({
      width: 18,
      height: 18,
      transform: isOpen ? 'translateY(-50%) rotate(90deg)' : 'translateY(-50%)',
      position: 'absolute',
      right: 20,
      top: '50%',
    } as CSSProperties),
  optionsContainer: {
    display: 'flex',
    flexDirection: 'column',
  } as React.CSSProperties,
  optionButton: (selected: boolean) => ({
    display: 'flex',
    alignItems: 'center',
    backgroundColor: selected ? COLORS.brand.primaryDark : COLORS.lightWhite,
    padding: 16,
    // marginBottom: 4,
    border: `1px solid ${selected ? COLORS.brand.primaryDark : COLORS.lightGray}`,
    borderTop: '1px solid transparent',
    height: 76,
  }),
  optionText: (selected: boolean) => ({
    color: selected ? COLORS.greyscale.white : COLORS.gray,
    fontSize: 14,
    fontWeight: 700,
    marginLeft: 16,
  }),
}

export default Accordion
